
















































































import { Mixins } from 'vue-mixin-decorator'
import { Component, Prop } from 'vue-property-decorator'

import UsualPowerMigrationConflictNotice from '@/components/molecules/UsualPowerMigrationConflictNotice.vue'
import AjaxErrorDialog from '@/components/organisms/dialog/ErrorDialog.vue'
import BehaviorConfig from '@/models/app-config/behavior/behavior'
import ContactLensFKU from '@/models/item/fku/contact-lens'
import ContactLensFKURepository from '@/models/item/fku/repository'
import ContactLensRootRepository from '@/models/item/root/repository'
import { createUsualPowerGetService } from '@/services/api/usual-power/usual-power'
import { EventBusForThirdParty } from '@/usecases/event-bus-for-third-party/event-bus'
import AppId from '@/util/appid'
import { BrandRouteResolver } from '@/util/brandRouteResolver'
import { log } from '@/util/log'
import ContactLensCartIn from '@ajax/vue/components/organisms/contact-lens/CartIn.vue'
import ContactLensColorDropdown from '@ajax/vue/components/organisms/contact-lens/ColorDropdown.vue'
import ContactLensColorVariation from '@ajax/vue/components/organisms/contact-lens/ColorVariation.vue'
import ContactLensPowerLeftArea from '@ajax/vue/components/organisms/contact-lens/power/LeftArea.vue'
import ContactLensPowerRightArea from '@ajax/vue/components/organisms/contact-lens/power/RightArea.vue'
import ContactLensQuantityDropdown from '@ajax/vue/components/organisms/contact-lens/Quantity.vue'
import BfcacheHandler from '@ajax/vue/mixin/BfcacheHandler'

import { moveCarousel } from '@ajax/vue/components/organisms/item-detail/interaction/move-carousel'
import ContactLensItemDetailStore from './store'
import ContactLensItemDetailStoreBuilder from './store-builder'

@Component({
  components: {
    AjaxErrorDialog,
    ContactLensCartIn,
    ContactLensColorDropdown,
    ContactLensColorVariation,
    ContactLensPowerLeftArea,
    ContactLensPowerRightArea,
    ContactLensQuantityDropdown,
    UsualPowerMigrationConflictNotice,
  },
})
export default class ContactLensUserSelectArea extends Mixins<BfcacheHandler>(BfcacheHandler) {
  @Prop({ required: true })
  rootId: string

  @Prop({ required: true })
  initialDisplayedFkuId: string

  /*
   * #8687 displayPriceMode パラメータの取得
   * 'simple': 合計価格を非表示（Google Marchant Center向け
   * undefined: 合計価格を表示（デフォルト）
   */
  @Prop({ default: undefined })
  displayPriceMode: 'simple' | undefined

  store: ContactLensItemDetailStore | null = null

  get brandEnglishName(): string {
    return BrandRouteResolver.resolveBrandFromPathElement(this.$route.params.brand_english_name)
  }

  /**
   * 表示ライフサイクルは通知側では持たず、度数を取得したこの画面が握る。
   * この画面では度数の保存は起きないため、表示中に条件が変わることはない
   */
  get shouldShowMigrationConflictNotice(): boolean {
    return this.store !== null && this.store.usualPowerMigrationConflicted
  }

  /**
   * TODO: ストアビルダ側に状態を移したい。
   * しかしストアビルダ側の状態をこのコンポーネントで利用しようとしたところ、リアクティブに反映されなかったため、いったんコンポーネント側の状態管理としている。
   */
  isLoading: boolean = false

  hasApiError: boolean = false
  errorMessage: string[] = []

  async created() {
    try {
      this.isLoading = true

      this.registerBfcacheHandler()

      const brandName = this.brandEnglishName
      const appId = AppId.getByBrandName(brandName)
      const behavior = BehaviorConfig.createFromBrand(brandName)

      this.store = await ContactLensItemDetailStoreBuilder.getInstance(
        new ContactLensRootRepository(appId),
        new ContactLensFKURepository(appId),
        createUsualPowerGetService(brandName)
      ).build(
        this.rootId,
        behavior,
        this.initialDisplayedFkuId
      )

      /**
       * ContactLensItemDetailStoreBuilderがシングルトンであるため、複数箇所でstoreが作成されても同じインスタンスを参照することになる。
       * したがってsubscribeする箇所は1箇所で良い（複数箇所でsubscribeすると重複したhandlerが登録される）
       * 具体的には、ColorVariation.vueでもstoreの初期化を行っているが、そちらではsubscribeを行っていない。
       *
       * 詳細はContactLensItemDetailStoreBuilder.getInstanceのコメントを参照
       */
      this.store.subscribeColorSelectionChanged((store, selectedFku) => {
        // 当該カラーのFKUの最初の画像にカルーセルのフォーカスを移動する
        // @see src/Template/Element/item/image_area.ctp
        moveCarousel(selectedFku.lensImageMediaId)

        this.publishProductDetailColorSelectionEventForThirdParty(store, behavior, selectedFku)
      })

      this.publishProductDetailViewEventForThirdParty(this.store, behavior, this.initialDisplayedFkuId)
    } catch (error) {
      log.error('Store build failed:', error)
      this.hasApiError = true
      this.errorMessage = [
        '商品情報の読み込みに失敗しました。',
        '※改善されない場合、お問い合わせよりカスタマーセンターまでお問い合わせください。',
      ]
    } finally {
      this.isLoading = false
    }
  }

  beforeDestroy(): void {
    this.unregisterBfcacheHandler()
  }

  // bfcacheから状態が復元された場合にkeyがインクリメントされる
  // keyを変更することで配下のselectとinput要素を再作成させる
  get key(): string {
    return `contact-lens-user-select-area-${this.renderingKey}`
  }

  private publishProductDetailViewEventForThirdParty(
    store: ContactLensItemDetailStore,
    behavior: BehaviorConfig,
    initialDisplayedFkuId: string
  ): void {
    EventBusForThirdParty.getInstance().publish('product-detail-view', {
      root: {
        name: store.root.name,
        brand: store.root.brandEnglishName,
        category: store.root.categoryPathnames,
      },
      fku: store.fkus.map(fku => ({
        id: fku.id,
        color: fku.colorLabel,
        isInitialDisplayed: fku.id === initialDisplayedFkuId,
        price: {
          min: fku.price.min,
          max: fku.price.max,
        },
        sku: fku.skus(behavior).map(sku => ({
          id: sku.id.long,
          short_id: sku.id.short,
          price: sku.price,
          sku_number: sku.skuNumber,
          isInitialDisplayed: fku.id === initialDisplayedFkuId,
        })),
      })),
    })
  }

  private publishProductDetailColorSelectionEventForThirdParty(
    store: ContactLensItemDetailStore,
    behavior: BehaviorConfig,
    selectedFku: ContactLensFKU
  ): void {
    EventBusForThirdParty.getInstance().publish('product-detail-color-selection', {
      productName: store.root.name,
      fkuId: selectedFku.id,
      colorName: selectedFku.colorLabel,
      sku: selectedFku.skus(behavior).map(sku => ({
        id: sku.id.long,
        price: sku.price,
      })),
    })
  }
}
